import ColorOnboardingUno from '../../../assets/Illustrations/color_onboarding_1.svg';
import ColorOnboardingDos from '../../../assets/Illustrations/color_onboarding_2.svg';
import ColorOnboardingTres from '../../../assets/Illustrations/color_onboarding_3.svg';
import ColorOnboardingCuatro from '../../../assets/Illustrations/color_onboarding_4.svg';
import ColorOnboardingCinco from '../../../assets/Illustrations/color_onboarding_5.svg';
import ColorOnboardingSeis from '../../../assets/Illustrations/color_onboarding_6.svg';
import ColorPagosInmediatosTutorial from '../../../assets/Illustrations/color_pagos_inmediatos_tutorial.svg';
import ColorPeopleWork from '../../../assets/Illustrations/color_people_work.svg';
import ColorPeopleEditing from '../../../assets/Illustrations/color_people_editing.svg';
import ColorQRUno from '../../../assets/Illustrations/color_qr_1.svg';
import ColorQRDos from '../../../assets/Illustrations/color_qr_2.svg';
import ColorQRTres from '../../../assets/Illustrations/color_qr_3.svg';
import ColorQRCuatro from '../../../assets/Illustrations/color_qr_4.svg';
import ColorQRCinco from '../../../assets/Illustrations/color_qr_5.svg';
import ColorQRSeis from '../../../assets/Illustrations/color_qr_6.svg';
import ColorTerminalesTutorTerminalesUno from '../../../assets/Illustrations/color_terminales_tutor_terminales_1.svg';
import ColorTerminalesTutorTerminalesDos from '../../../assets/Illustrations/color_terminales_tutor_terminales_2.svg';
import ColorTerminalesTutorTerminalesTres from '../../../assets/Illustrations/color_terminales_tutor_terminales_3.svg';
import ColorTerminalesTutorTerminalesCuatro from '../../../assets/Illustrations/color_terminales_tutor_terminales_4.svg';
import FilledFeedbackError from '../../../assets/Illustrations/filled_feedback_error.svg';
import FilledFeedbackSuccess from '../../../assets/Illustrations/filled_feedback_success.svg';
import FilledFeedbackWarning from '../../../assets/Illustrations/filled_feedback_warning.svg';
import GreyPeopleError from '../../../assets/Illustrations/grey_people_error.svg';
import LinealAccionistrasYSociosEmpty from '../../../assets/Illustrations/lineal_accionistasysocios_empty.svg';
import LinealAltaUsuarioWarning from '../../../assets/Illustrations/lineal_alta_usuario_warning.svg';
import LinealAppUpdate from '../../../assets/Illustrations/lineal_app_update.svg';
import LinealAppUpdateAppUpdate from '../../../assets/Illustrations/lineal_appupdate_appupdate.svg';
import LinealArchivoAdjunto from '../../../assets/Illustrations/lineal_archivo_adjunto.svg';
import LinealBiometriaDefault from '../../../assets/Illustrations/lineal_biometria_default.svg';
import LinealBiometriaWarning from '../../../assets/Illustrations/lineal_biometria_warning.svg';
import LinealBtnDePagoDefault from '../../../assets/Illustrations/lineal_btn_de_pago_default.svg';
import LinealBtnDePagoError from '../../../assets/Illustrations/lineal_btn_de_pago_error.svg';
import LinealBtnDePagoNoDisponible from '../../../assets/Illustrations/lineal_btn_de_pago_no_disponible.svg';
import LinealBtnDePagoGenerado from '../../../assets/Illustrations/lineal_btn_de_pago_pago_generado.svg';
import LinealBtnDePagoSinGenerar from '../../../assets/Illustrations/lineal_btn_de_pago_sin_generar.svg';
import LinealBtnDePagoWarning from '../../../assets/Illustrations/lineal_btn_de_pago_warning.svg';
import LinealCalendarioDefault from '../../../assets/Illustrations/lineal_calendario_default.svg';
import LinealCalendarioFeriado from '../../../assets/Illustrations/lineal_calendario_feriado.svg';
import LinealCobroAnticipadoDesactivar from '../../../assets/Illustrations/lineal_cobro_anticipado_desactivar.svg';
import LinealCobroAnticipadoError from '../../../assets/Illustrations/lineal_cobro_anticipado_error.svg';
import LinealCobroAnticipadoSinGenerar from '../../../assets/Illustrations/lineal_cobro_anticipado_sin_generar.svg';
import LinealCobroAnticipadoWarning from '../../../assets/Illustrations/lineal_cobro_anticipado_warning.svg';
import LinealColaboradoresAlta from '../../../assets/Illustrations/lineal_colaboradores_alta.svg';
import LinealDireccionActualizar from '../../../assets/Illustrations/lineal_direccion_actualizar.svg';
import LinealDireccionError from '../../../assets/Illustrations/lineal_direccion_error.svg';
import LinealDNIDorso from '../../../assets/Illustrations/lineal_dni_dorso.svg';
import LinealDNIFrente from '../../../assets/Illustrations/lineal_dni_frente.svg';
import LinealDocumentationSuccess from '../../../assets/Illustrations/lineal_documentation_success.svg';
import LinealEstablecimientosEmpty from '../../../assets/Illustrations/lineal_establecimientos_empty.svg';
import LinealEstablecimientosWarning from '../../../assets/Illustrations/lineal_establecimientos_warning.svg';
import LinealLiquidacionesDocumentosGuardados from '../../../assets/Illustrations/lineal_liquidaciones_documentos_guardados.svg';
import LinealLiquidacionesEmpty from '../../../assets/Illustrations/lineal_liquidaciones_empty.svg';
import LinealLiquidacionesError from '../../../assets/Illustrations/lineal_liquidaciones_error.svg';
import LinealConciliacionCrear from '../../../assets/Illustrations/lineal_conciliacion_crear.svg';
import LinealMailConfirmado from '../../../assets/Illustrations/lineal_mail_confirmado.svg';
import LinealMailCreado from '../../../assets/Illustrations/lineal_mail_creado.svg';
import LinealMailWarning from '../../../assets/Illustrations/lineal_mail_warning.svg';
import LinealNotificacionesEmpty from '../../../assets/Illustrations/lineal_notificaciones_empty.svg';
import LinealPagosInmediatosDefault from '../../../assets/Illustrations/lineal_pagos_inmediatos_default.svg';
import LinealPasswordAdd from '../../../assets/Illustrations/lineal-password-add.svg';
import LinealPasswordConfirm from '../../../assets/Illustrations/lineal_password_confirm.svg';
import LinealPasswordError from '../../../assets/Illustrations/lineal_password_error.svg';
import LinealPasswordRecuperar from '../../../assets/Illustrations/lineal_password_recuperar.svg';
import LinealQRDefault from '../../../assets/Illustrations/lineal_qr_default.svg';
import LinealQRLoader from '../../../assets/Illustrations/lineal_qr_loader.svg';
import LinealQRSucess from '../../../assets/Illustrations/lineal_qr_success.svg';
import LinealQRWarning from '../../../assets/Illustrations/lineal_qr_warning.svg';
import LinealSistemaError from '../../../assets/Illustrations/lineal_sistema_error.svg';
import LinealSistemaNoResults from '../../../assets/Illustrations/lineal_sistema_no_results.svg';
import LinealSistemaNotFound from '../../../assets/Illustrations/lineal_sistema_not_found.svg';
import LinealSistemaRateApp from '../../../assets/Illustrations/lineal_sistema_rate_app.svg';
import LinealTerminalDefault from '../../../assets/Illustrations/lineal_terminal_default.svg';
import LinealTerminalError from '../../../assets/Illustrations/lineal_terminal_error.svg';
import LinealTerminalNumero from '../../../assets/Illustrations/lineal_terminal_numero.svg';
import LinealTimeWarning from '../../../assets/Illustrations/lineal_time_warning.svg';
import LinealUsuarioAltaError from '../../../assets/Illustrations/lineal_usuario_alta_error.svg';
import LinealUsuarioAlta from '../../../assets/Illustrations/lineal_usuario_alta.svg';
import LinealUsuarioCuentaBloqueada from '../../../assets/Illustrations/lineal_usuario_cuenta_bloqueada.svg';
import LinealSesionExpirada from '../../../assets/Illustrations/lineal_sesion_expirada.svg';
import Avatar from '../../../assets/Illustrations/avatar.svg';
import Password from '../../../assets/Illustrations/password.svg';
import LogoAndreani from '../../../assets/Illustrations/logo-Andreani.svg';
import LinealListadoAlerta from '../../../assets/Illustrations/lineal_listado_alerta.svg';
import SuccessButWait from '../../../assets/Illustrations/success_but_wait.svg';

export const IllustrationAssets = {
  avatar: Avatar,
  password: Password,
  color_onboarding_1: ColorOnboardingUno,
  color_onboarding_2: ColorOnboardingDos,
  color_onboarding_3: ColorOnboardingTres,
  color_onboarding_4: ColorOnboardingCuatro,
  color_onboarding_5: ColorOnboardingCinco,
  color_onboarding_6: ColorOnboardingSeis,
  color_pagos_inmediatos_tutorial: ColorPagosInmediatosTutorial,
  color_people_work: ColorPeopleWork,
  color_people_editing: ColorPeopleEditing,
  color_qr_1: ColorQRUno,
  color_qr_2: ColorQRDos,
  color_qr_3: ColorQRTres,
  color_qr_4: ColorQRCuatro,
  color_qr_5: ColorQRCinco,
  color_qr_6: ColorQRSeis,
  color_terminales_tutor_terminales_1: ColorTerminalesTutorTerminalesUno,
  color_terminales_tutor_terminales_2: ColorTerminalesTutorTerminalesDos,
  color_terminales_tutor_terminales_3: ColorTerminalesTutorTerminalesTres,
  color_terminales_tutor_terminales_4: ColorTerminalesTutorTerminalesCuatro,
  filled_feedback_error: FilledFeedbackError,
  filled_feedback_success: FilledFeedbackSuccess,
  filled_feedback_warning: FilledFeedbackWarning,
  grey_people_error: GreyPeopleError,
  lineal_accionistasysocios_empty: LinealAccionistrasYSociosEmpty,
  lineal_alta_usuario_warning: LinealAltaUsuarioWarning,
  lineal_app_update: LinealAppUpdate,
  lineal_appupdate_appupdate: LinealAppUpdateAppUpdate,
  lineal_archivo_adjunto: LinealArchivoAdjunto,
  lineal_biometria_default: LinealBiometriaDefault,
  lineal_biometria_warning: LinealBiometriaWarning,
  lineal_btn_de_pago_default: LinealBtnDePagoDefault,
  lineal_btn_de_pago_error: LinealBtnDePagoError,
  lineal_btn_de_pago_no_disponible: LinealBtnDePagoNoDisponible,
  lineal_btn_de_pago_pago_generado: LinealBtnDePagoGenerado,
  lineal_btn_de_pago_sin_generar: LinealBtnDePagoSinGenerar,
  lineal_btn_de_pago_warning: LinealBtnDePagoWarning,
  lineal_calendario_default: LinealCalendarioDefault,
  lineal_calendario_feriado: LinealCalendarioFeriado,
  lineal_cobro_anticipado_desactivar: LinealCobroAnticipadoDesactivar,
  lineal_cobro_anticipado_error: LinealCobroAnticipadoError,
  lineal_cobro_anticipado_sin_generar: LinealCobroAnticipadoSinGenerar,
  lineal_cobro_anticipado_warning: LinealCobroAnticipadoWarning,
  lineal_colaboradores_alta: LinealColaboradoresAlta,
  lineal_direccion_actualizar: LinealDireccionActualizar,
  lineal_direccion_error: LinealDireccionError,
  lineal_dni_dorso: LinealDNIDorso,
  lineal_dni_frente: LinealDNIFrente,
  lineal_establecimientos_empty: LinealEstablecimientosEmpty,
  lineal_establecimientos_warning: LinealEstablecimientosWarning,
  lineal_liquidaciones_documentos_guardados:
    LinealLiquidacionesDocumentosGuardados,
  lineal_liquidaciones_empty: LinealLiquidacionesEmpty,
  lineal_liquidaciones_error: LinealLiquidacionesError,
  lineal_conciliacion_crear: LinealConciliacionCrear,
  lineal_mail_confirmado: LinealMailConfirmado,
  lineal_mail_creado: LinealMailCreado,
  lineal_mail_warning: LinealMailWarning,
  lineal_notificaciones_empty: LinealNotificacionesEmpty,
  lineal_pagos_inmediatos_default: LinealPagosInmediatosDefault,
  lineal_password_add: LinealPasswordAdd,
  lineal_password_confirm: LinealPasswordConfirm,
  lineal_password_error: LinealPasswordError,
  lineal_password_recuperar: LinealPasswordRecuperar,
  lineal_qr_default: LinealQRDefault,
  lineal_qr_loader: LinealQRLoader,
  lineal_qr_success: LinealQRSucess,
  lineal_qr_warning: LinealQRWarning,
  lineal_sistema_error: LinealSistemaError,
  lineal_sistema_no_results: LinealSistemaNoResults,
  lineal_sistema_not_found: LinealSistemaNotFound,
  lineal_sistema_rate_app: LinealSistemaRateApp,
  lineal_terminal_default: LinealTerminalDefault,
  lineal_terminal_error: LinealTerminalError,
  lineal_terminal_numero: LinealTerminalNumero,
  lineal_time_warning: LinealTimeWarning,
  lineal_usuario_alta_error: LinealUsuarioAltaError,
  lineal_usuario_alta: LinealUsuarioAlta,
  lineal_usuario_cuenta_bloqueada: LinealUsuarioCuentaBloqueada,
  lineal_sesion_expirada: LinealSesionExpirada,
  lineal_documentation_success: LinealDocumentationSuccess,
  logo_andreani: LogoAndreani,
  lineal_listado_alerta: LinealListadoAlerta,
  success_but_wait: SuccessButWait,
};
